import React, { useEffect, useState, useContext, Fragment } from "react";
import SharedDataContext from "../../_helper/SharedData";
import { showAlert } from "../../Services/Shared.service";
import { Breadcrumbs, Btn, H6 } from "../../AbstractElements";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import {
  getPackage,
  getPackageRate,
  getPackageRatesList,
  getPackagesList,
  getPackagesListBySearch,
  getPackagesRateListBySearch,
  getPackageRatesListByPackId,
} from "../../Services/Packages.service";
import { Plus } from "react-feather";
import PackagesRateTable from "../PackageRates/PackagesRateTable";
import SearchTable from "../Common/Component/SearchTable";
import PackageRateInput from "../PackageRates/PackageRateInput";
import { CalendarViewFunctions } from "../PackageRates/Components/CalendarViewFunctions";
import PackageRateCalendar from "../PackageRates/PackageRateCalendar";
import CustomSelect from "../../CommonElements/CustomSelect";
import { Switch } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import TableChartIcon from '@mui/icons-material/TableChart';
const calendarViewFunctions = new CalendarViewFunctions();

function PackageRatesTable({ packId }) {
  const { cityData, globalCityField, setShowApiLoader } =
    useContext(SharedDataContext);
  const [tableData, setTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 30,
  });
  const [searchData, setSearchData] = useState("");
  const [paginationTotalRows, setPaginationTotalRows] = useState(0);
  const [calendarData, setCalendarData] = useState([]);
  const [tableHeaders, setTableHeaders] = useState([]);
  const [packagesData, setPackagesData] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [editIdRates, setEditIdRates] = useState("");
  const [filterType, setFilterType] = useState("");
  const[isTable,setTable] = useState(true);

  const onChangePage = (page) => {
    console.log("page", page);
    setPagination({
      ...pagination,
      pageIndex: page - 1,
    });
  };
  const onPackageNameClicked = (packageDetails) => {
    setSelectedPackage(packageDetails);
    setIsOpen(true);
  };

  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };

  const toggleModal = () => {
    fetchTableData();
    setEditIdRates("");
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    let obj = {
      packId: packId,
      page: pagination.pageIndex,
      size: pagination.pageSize,
    };
    getPackageRatesListByPackId(obj)
      .then(async (result) => {
        console.log("packageRate List from table is ", result.data);
        setPaginationTotalRows(result.data.count);
        setTableData(result.data.searchResponse);
        setCalendarData(
          await calendarViewFunctions.getCalendarData(
            result.data.searchResponse,
            onEditsClick,
            onPackageNameClicked
          )
        );
        setTableHeaders(await calendarViewFunctions.getTableHeaderWithHours());
        disableLoaders();
      })
      .catch((err) => {
        console.log("err", err);
        disableLoaders();
       
      });
  }, []);

  const fetchTableData = () => {
    if (!searchData) {
      let obj = {
        packId: packId,
        page: pagination.pageIndex,
        size: pagination.pageSize,
      };
      setLoader(true);
      getPackageRatesListByPackId(obj)
        .then(async (result) => {
          console.log("packageRate List from table is ", result.data);
          setPaginationTotalRows(result.data.count);
          setTableData(result.data.searchResponse);
          setCalendarData(
            await calendarViewFunctions.getCalendarData(
              result.data.searchResponse,
              onEditsClick,
              onPackageNameClicked
            )
          );
          setTableHeaders(
            await calendarViewFunctions.getTableHeaderWithHours()
          );
          disableLoaders();
        })
        .catch((err) => {
          console.log("err", err);
          disableLoaders();
        });
    } else if (searchData && filterType == "search") {
      const serviceCityId = globalCityField.value?.id || null;
      let obj = {
        serviceCityId: serviceCityId,
        name: searchData,
        page: pagination.pageIndex,
        size: pagination.pageSize,
      };
      setLoader(true);
      getPackagesRateListBySearch(obj)
        .then(async (result) => {
          setPaginationTotalRows(result.data.count);
          setTableData(result.data.searchResponse);
          setCalendarData(
            await calendarViewFunctions.getCalendarData(
              result.data.searchResponse,
              onEditsClick,
              onPackageNameClicked
            )
          );
          setTableHeaders(
            await calendarViewFunctions.getTableHeaderWithHours()
          );
          disableLoaders();
        })
        .catch((err) => {
          console.log("err", err);
          disableLoaders();
          showAlert(
            "error",
            err.response?.data?.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    }
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setPagination({
      ...pagination,
      pageSize: currentRowsPerPage,
    });
  };
  const onEditsClick = (obj) => {
    setIsOpen(true);
    setEditIdRates(obj.id);
  };

  return (
    <div>
       
      
      <PackageRateCalendar
        packageRatesData={tableData}
        calendarData={calendarData}
        setCalendarData={setCalendarData}
        tableHeaders={tableHeaders}
        setTableHeaders={setTableHeaders}
        pagination={pagination}
        setPagination={setPagination}
        paginationTotalRows={paginationTotalRows}
        onEditClick={onEditsClick}
        loader={loader}
      />
      <PackageRateInput
        editId={editIdRates}
        isOpen={isOpen}
        toggleModal={toggleModal}
        packagesData={packagesData}
        selectedPackage={selectedPackage}
      />
    
    </div>

  );
}

export default PackageRatesTable;
